import React from 'react';
import {Link} from 'react-router-dom';
import AurSearchBox from '../../../common/aur-search-box/AurSearchBox';

const SearchBox: React.FC = () => {
  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>Search Box</h1>
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '32px'}}>
          <AurSearchBox />
        </div>
      </div>
    </>
  );
};

export default SearchBox;
